
<table mat-table [dataSource]="dataSource" class="mat-elevation-z1" matSort>

  <ng-container *ngFor="let column of listColunas;let p = index">
    <ng-container [matColumnDef]="column.id">
      <th mat-header-cell *matHeaderCellDef> {{ column.label }} </th>
      <td mat-cell *matCellDef="let element" [style]="p > 0 ? 'overflow-wrap: anywhere' : ''">
        {{ column.id == 'posicao' ? (siglaPosicao + element[column.id]) : element[column.id] }}
      </td>
    </ng-container>
  </ng-container>

  <!-- AÇÕES - MODO VISUALIZAR (somente o botão de olho) -->
  <ng-container matColumnDef="acoes">
    <th mat-header-cell *matHeaderCellDef class="text-center">Ações</th>
    <td mat-cell *matCellDef="let element">
      <div class="d-flex justify-content-center">
        <!-- Se estiver no modo de visualização -->
        <button
          *ngIf="visualizar"
          class="icon-btn btn btn-primary btn-xs text-left"
          (click)="editar(element)">
          <i class="far fas fa-eye fa-sm"></i>
        </button>

        <!-- Se estiver no modo de edição -->
        <ng-container *ngIf="!visualizar">
          <button
            class="icon-btn btn btn-primary btn-xs text-left"
            (click)="editar(element)">
            <i class="far fas fa-pen fa-sm"></i>
          </button>
          <button
            class="icon-btn btn btn-danger btn-xs text-left ml-1"
            (click)="excluir(element)">
            <i class="far fa-trash-alt"></i>
          </button>
          <button
            class="icon-btn btn btn-secondary btn-xs text-left ml-1"
            (click)="moveUp(element)">
            <i class="fas fa-arrow-up"></i>
          </button>
          <button
            class="icon-btn btn btn-secondary btn-xs text-left ml-1"
            (click)="moveDown(element)">
            <i class="fas fa-arrow-down"></i>
          </button>
        </ng-container>
      </div>
    </td>
  </ng-container>



  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

</table>

<mat-paginator [pageSize]="5" [pageSizeOptions]="[5, 30, 50]" showFirstLastButtons>
</mat-paginator>
